import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../Baseurl";

const ShippingAddress = ( ) => {

    const user_id = localStorage.getItem("cust_id");

    console.log("user_id", user_id);

  const [formData, setFormData] = useState({
    full_name: "",
    phone_number: "",
    alternate_phone: "",
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    postal_code: "",
    country: "India",
    landmark: "",
    address_type: "Home",
    is_default: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.full_name || !formData.address_line1 || !formData.city || !formData.state || !formData.postal_code) {
//       Swal.fire("Error", "Please fill all required fields.", "error");
//       return;
//     }

//     try {
//       const payload = { ...formData, user_id };
//       const res = await axios.post(`${baseurl}addShippingAddress`, payload); // Adjust endpoint as needed

//       if (res.data.success) {
//         Swal.fire("Success", "Address saved successfully.", "success");
//         setFormData({
//           full_name: "",
//           phone_number: "",
//           alternate_phone: "",
//           address_line1: "",
//           address_line2: "",
//           city: "",
//           state: "",
//           postal_code: "",
//           country: "India",
//           landmark: "",
//           address_type: "Home",
//           is_default: false,
//         });
//       } else {
//         throw new Error();
//       }
//     } catch (error) {
//       console.error("Save error:", error);
//       Swal.fire("Error", "Failed to save address.", "error");
//     }
//   };



const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!formData.full_name || !formData.address_line1 || !formData.city || !formData.state || !formData.postal_code) {
      Swal.fire("Error", "Please fill all required fields.", "error");
      return;
    }
  
    try {
      const payload = { ...formData, user_id };
console.log("payload", payload);

      const res = await axios.post(`${baseurl}addShippingAddress`, payload);
  
      if (res.data.success) {
        Swal.fire("Success", "Address saved successfully.", "success").then(() => {
          window.location.reload(); // Reload the page after alert is closed
        });
      } else {
        throw new Error("Save failed");
      }
    } catch (error) {
      console.error("Save error:", error);
      Swal.fire("Error", "Failed to save address.", "error");
    }
  };
  
  




  return (

    <>


<div className="text-start">
<span  class="spal text-start" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
  Add Shipping Address
</span>
</div>
 


 
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        {/* <h5 class="modal-title" id="staticBackdropLabel">Add Shipping Address</h5> */}
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-start">
      <form onSubmit={handleSubmit} className="card p-3 border rounded mb-3">
      <h5 className="mb-3">Shipping Address</h5>

      <div className="mb-2">
        <label>Full Name *</label>
        <input name="full_name" className="form-control" value={formData.full_name} onChange={handleChange} required />
      </div>

      <div className="mb-2">
        <label>Phone Number</label>
        <input name="phone_number" className="form-control" value={formData.phone_number} onChange={handleChange} />
      </div>

      <div className="mb-2">
        <label>Alternate Phone</label>
        <input name="alternate_phone" className="form-control" value={formData.alternate_phone} onChange={handleChange} />
      </div>

      <div className="mb-2">
        <label>Address Line 1 *</label>
        <input name="address_line1" className="form-control" value={formData.address_line1} onChange={handleChange} required />
      </div>

      <div className="mb-2">
        <label>Address Line 2</label>
        <input name="address_line2" className="form-control" value={formData.address_line2} onChange={handleChange} />
      </div>

      <div className="mb-2">
        <label>City *</label>
        <input name="city" className="form-control" value={formData.city} onChange={handleChange} required />
      </div>

      <div className="mb-2">
        <label>State *</label>
        <input name="state" className="form-control" value={formData.state} onChange={handleChange} required />
      </div>

      <div className="mb-2">
        <label>Postal Code *</label>
        <input name="postal_code" className="form-control" value={formData.postal_code} onChange={handleChange} required />
      </div>

      <div className="mb-2">
        <label>Country</label>
        <input name="country" className="form-control" value={formData.country} onChange={handleChange} />
      </div>

      <div className="mb-2">
        <label>Landmark</label>
        <input name="landmark" className="form-control" value={formData.landmark} onChange={handleChange} />
      </div>

      <div className="mb-2">
        <label>Address Type</label>
        <select name="address_type" className="form-select" value={formData.address_type} onChange={handleChange}>
          <option value="Home">Home</option>
          <option value="Office">Office</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div className="mb-3 form-check">
        <input
          type="checkbox"
          name="is_default"
          className="form-check-input"
          checked={formData.is_default}
          onChange={handleChange}
        />
        <label className="form-check-label">Set as Default Address</label>
      </div>

      <button type="submit" className="btn btn-primary">Save Address</button>
    </form>
      </div>
      
    </div>
  </div>
</div>



    
    </>
  );
};

export default ShippingAddress;
